
      let options = {"masterHistoryType":"browser","base":"/","apps":[{"name":"product-app","entry":"/product-micro","prefetch":true}]};
      export const getMasterOptions = () => options;
      export const setMasterOptions = (newOpts) => options = ({ ...options, ...newOpts });
      